<i-assistance
  [phone]="supportDetails.phone"
  [email]="supportDetails.email"
  [guideMode]="false"
  [versions]="versions()"
></i-assistance>
